import React from 'react';
import { FuelSite, ErrorType } from '../../types';

export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_BRANCH_DETAILS = 'SET_BRANCH_DETAILS';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';

export interface Customer {
  customerNumber: string;
  authenticationToken: string;
  fuelSites: FuelSite[];
}

export interface BankBranch {
  valid: boolean;
  bsbNumber: string;
  displayName: string;
  hideDisplayName: boolean;
}

interface ErrorSteps {
  status: boolean;
  type: ErrorType;
}

export interface Error {
  steps: ErrorSteps[];
}

export interface FormContainerValues {
  stateShortName: any;
  customer: Customer;
  bankBranch: BankBranch;
  error: Error;
}

export type FormContainerActionTypes =
  | 'SET_CUSTOMER'
  | 'SET_BRANCH_DETAILS'
  | 'SET_ERROR'
  | 'RESET_ERROR';

export interface FormContainerAction {
  type: FormContainerActionTypes;
  value: FormContainerValues;
}

export interface FormContainer {
  values: FormContainerValues;
  dispatch: React.Dispatch<FormContainerAction>;
}
